import { Component } from 'react';
import { Loading3QuartersOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
import "./style.less";

class Loading extends Component {
    constructor(props) {
        super(props);
        this.state = {
            tip: this.props.tip,
        };
    }
    componentDidMount() {
    }
    render() {
        const antIcon = <Loading3QuartersOutlined style={{ fontSize: 24, color: '#b31b34' }} spin />;
        return (
            <Spin indicator={antIcon} tip={this.state.tip}>
                <div className="spin-wrapper-block"></div>
            </Spin>
        );
    }
}

export default Loading;

